import { useT, type Translate } from '@zagru/platform';

/**
 * The shell's strings (header, rail, workspace control, palette, connectivity) live in the one catalogue per
 * language since W11, so every shipped language translates them the same way as the rest of the product.
 * `useShellT` stays as the shell's name for the translator.
 */
export type ShellTranslate = Translate;

export function useShellT(): ShellTranslate {
  return useT();
}
